module.exports = __webpack_public_path__ + "static/media/layout-two-3.fa030f95.jpg";